<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="d-flex flex-wrap xrx-pagination-wrapper justify-content-center justify-content-sm-end">
  <ul class="pagination">
    <li
      class="page-item"
      [ngClass]="{ disabled: firstDisabled }"
      (click)="firstPage($event)">
      <a
        aria-label="First"
        href=""
        class="page-link"
        tabindex="-1"
        aria-disabled="false">
        <span aria-hidden="true" class="xgl-navigate_first"></span>
      </a>
    </li>
    <li
      class="page-item"
      [ngClass]="{ disabled: leftDisabled }"
      (click)="prevPage($event)">
      <a
        aria-label="Previous"
        href=""
        class="page-link"
        tabindex="-1"
        aria-disabled="true"
        [ngClass]="{ disabled: leftDisabled }">
        <span aria-hidden="true" class="xgl-navigate_left"></span>
      </a>
    </li>

    <!-- Pages -->
    @for (page of displayList; track page; let i = $index) {
      <li class="page-item" [ngClass]="{ active: page == currentPage }">
        <a
          aria-label="Page"
          href=""
          class="page-link"
          tabindex="-1"
          (click)="selectPage($event, page)">
          <span aria-hidden="true" class="">{{ page }}</span>
        </a>
      </li>
    }

    @if (loadingNextPage) {
      <li class="page-item disabled">
        <a
          aria-label="Spin"
          href=""
          class="page-link point-events-none"
          tabindex="-1"
          aria-disabled="true">
          <span class="xrx-activity-indicator ai-xs ai-spin"></span>
        </a>
      </li>
    }
    @if (!loadingNextPage) {
      <li
        class="page-item"
        [ngClass]="{ disabled: rightDisabled }"
        (click)="nextPage($event)">
        <a
          aria-label="Next"
          href=""
          class="page-link"
          tabindex="-1"
          aria-disabled="true">
          <span aria-hidden="true" class="xgl-navigate_right"></span>
        </a>
      </li>
    }
    @if (loadingLastPage) {
      <li class="page-item disabled">
        <a
          aria-label="Spin"
          href=""
          class="page-link point-events-none"
          tabindex="-1"
          aria-disabled="true">
          <span class="xrx-activity-indicator ai-xs ai-spin"></span>
        </a>
      </li>
    }
    @if (!loadingLastPage) {
      <li
        class="page-item"
        [ngClass]="{ disabled: lastDisabled }"
        (click)="lastPage($event)">
        <a aria-label="Last" href="" class="page-link" tabindex="-1">
          <span aria-hidden="true" class="xgl-navigate_last"></span>
        </a>
      </li>
    }
  </ul>

  <div class="pagination page-size">
    @if (pageSizeList !== null) {
      <xacc-select
        [list]="pageSizeList"
        property="size"
        localize="size"
        [(selectedItem)]="pageSizeSelect"
        (change)="selectPageSize($event)"
        class="ml-sm-3">
      </xacc-select>
    }
  </div>
</div>
